const Content = {
  'people': {
    'popup': {
      'titles': {
        'top': 'Profile',
        'phone': 'Phone',
        'follow': 'Connect',
        'favourites': 'Five Favorites'
      }
    }
  }
};

export { Content };
